export function readableCount(count: number): string {
	if (count < 1000) {
		return `${count}`;
	}
	if (count < 1000000) {
		return Math.floor(count / 1000) + "k";
	}
	return Math.floor(count / 1000000) + "M";
}
